/* eslint-disable react-hooks/exhaustive-deps */
import {t} from "../../../i18n";
import {Modal} from "react-bootstrap";
import Title from "../../../layout/Title";
import {useDispatch} from "react-redux";
import {LoginStatus} from "../../../http/Types";
import {useEffect, useRef, useState} from "react";
import {getContainer} from "../../../ioc/IOCSetup";
import {ContentModelName} from "../../../contenful/types";
import {handleModalPath, resetVerifyProcess} from "../../../user/UserActions";
import {fetchAndParseContent} from "../../../contenful/ContentfulActions";
import {ModalProps, PATH} from "../UserModalController";
import {LoginVerification} from "../../../http/protocol";
import FormContainer from "../../../layout/FormContainer";
import VerifyEmailForm from "../../../user/ui/VerifyEmailForm";
import ModalCloseBtn from "../ui/ModalCloseBtn";
import {Spinner} from "../../../ui/Spinner";
import {isHomeScreen, setModalPath, useClickOutside} from "../utils";
import {Status as JourneyStatus} from "../../../journey/UserJourneyReducer";
import Loader from "../../../layout/Loader";

const VerifyEmailModal = ({...rest}: Partial<ModalProps>) => {
  const {location, history, user, content, journey } = rest;
  const dispatch = useDispatch();
  const homeScreen = isHomeScreen();

  const ref = useRef(null);
  useClickOutside(ref, () => setModalPath({path: undefined, history}));

  // Defualt language is set in contentful
  const [ language ] = useState(()=> {
    try {
      return getContainer().getSettingsService().getActiveLocale().code;
    } catch (_) {
      return undefined
    }
  })

  // Get Onboarding content
  useEffect(() => {
    if(content && content.global === undefined){
      dispatch(fetchAndParseContent(ContentModelName.GLOBAL, language) as any);
    }
    return () => {
      dispatch(resetVerifyProcess());
    };
  }, []);

  // Redirect to right modal based in registration proccess.
  const userStatus = user && user.status;

  useEffect(()=>{
    if(history && location){

      const verificationRequired = userStatus == LoginStatus.VERIFICATION_REQUIRED
          || userStatus == LoginStatus.MFA_VERIFICATION_REQUIRED
          || userStatus == LoginStatus.MFA_VERIFICATION_ERROR;
      const hasVerificationLogin = user?.registration || user?.manualLoginRequest;
      if(userStatus === LoginStatus.LOGGED_IN){
        if(location.search.includes(PATH.NEW_USER)){
          setModalPath({path: {type: PATH.REGISTER_SUCCESS, modal: PATH.MODAL_TYPE}, history})
        } else {
          setModalPath({path: undefined, history}) 
        }
      } else if(!verificationRequired && !hasVerificationLogin) {
        setModalPath({path: undefined, history});
      }

      if(userStatus === LoginStatus.ACCEPT_TERMS_REQUIRED){
        if(location.search.includes(PATH.NEW_USER)){
          setModalPath({path: {type: PATH.TERMS_CONDITION, modal: PATH.NEW_USER}, history})
        } else {
          setModalPath({path: {type: PATH.TERMS_CONDITION, modal: PATH.MODAL_TYPE}, history})

        }
      }
    }
    return () => {
      if (userStatus === LoginStatus.LOGGED_IN || userStatus === LoginStatus.ACCEPT_TERMS_REQUIRED) {
        dispatch(handleModalPath(false, false));
      }
    };
  }, [user]);



  const verification = user && user.manualLoginRequest?.verification === LoginVerification.PHONE
  const LoadingSpinner = <div id="sc" data-testid={PATH.VERIFY_EMAIL}><Spinner/></div>

  let isPhone = user?.manualLoginRequest?.verification == LoginVerification.PHONE;
  let isEmail = user?.manualLoginRequest?.verification == LoginVerification.EMAIL;

  if((!isPhone && !isEmail)) {
    return (
        <div data-testid={PATH.VERIFY_EMAIL} className={`modal-wrapper ${PATH.VERIFY_EMAIL} ${!homeScreen ? "active" : null}`} ref={!homeScreen ? ref : null}>
          <div className="modal-container">
            <Modal.Body>
              <div className={"modal-loader-container"}>
                <Loader />
              </div>
            </Modal.Body>
          </div>
        </div>
    );
  }

  if(journey && journey?.status !== JourneyStatus.DONE){
    return LoadingSpinner
  }

  return (
    <div className={`modal-wrapper ${PATH.VERIFY_EMAIL} ${!homeScreen ? "active" : null}`} ref={!homeScreen ? ref : null}>
      {!homeScreen && <ModalCloseBtn onClick={()=>setModalPath({path: undefined, history})}/>}
      <div className="modal-container">
        <Modal.Header>
        <Title animate={true} title={t("account." + (verification ? "verifyPhoneNumberTitle" : "verifyEmailTitle"))} />
        {user?.newDevice && <div className={"new-device"}>{t("account.new-device-title")}</div>}
        </Modal.Header>
        <Modal.Body>
        <FormContainer>
            <VerifyEmailForm />
        </FormContainer>
        </Modal.Body>
      </div>
    </div>
  );
};


export default VerifyEmailModal;

